import RaceMixins from '../../../../../components/_mixins/races'
import config from '../../../../../lib/config'
const {BASE_IMAGES: reImagePath} = config

export default {
  name: 'timeslot-group',
  props: {
    time: {default: null}
  },
  mixins: [RaceMixins],
  components: {},
  data() {
    return {
      racerImageUri: reImagePath + '/place.png'
    }
  },
  computed: {
    item() {
      return this.retrievedTimeslot(this.time)
    },
    racersCount: {
      get() {
        return this.item.racers || 0
      },
      set(value) {
        this.setTimeslotData({time: this.time, key: 'racers', value: value})
      }
    },
    tMemberCount: {
      get() {
        return this.item.tMembers || 0
      },
      set(value) {
        this.setTimeslotData({time: this.time, key: 'tMembers', value: value})
      }
    },
    racerLimit() {
      const item = this.item
      const playerLimit = this.totalPlayers
      return Math.min(item.karts, playerLimit)
    },
    tMemberLimit() {
      return Math.min(this.racersCount, this.totalMembersNotSlotted + this.tMemberCount)
    }
  },
  methods: {
    removeMe() {
      this.removeTimeslot(this.item)
    },
    addRacer() {
      ++this.racersCount
    },
    subRacer() {
      const count = this.racersCount - 1
      if (this.tMemberCount > count) {
        this.tMemberCount = count
      }
      --this.racersCount
    },
    addTMember() {
      ++this.tMemberCount
    },
    subTMember() {
      --this.tMemberCount
    },
  }
}
